import styled from "styled-components";
import { ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  ModalProvider,
  PaginationProvider,
  Tabs,
  UpgradeSubscriptionModalType,
} from "dash-ui";

import ViewedProperties from "./components/ViewedProperties/ViewedProperties";
import AddedToPortfolio from "./components/AddedToPortfolio/AddedToPortfolio";
import UpgradeSubscriptionModal from "common/components/UpgradeSubscriptionModal/UpgradeSubscriptionModal";
import { SubscriptionChangeConfirmationModal } from "pages/ProfilePage/components/ProfileBilling/components";

enum BrokerActivityTabs {
  VIEWED_PROPERTIES = "VIEWED_PROPERTIES",
  ADDED_TO_PORTFOLIO = "ADDED_TO_PORTFOLIO",
}

const StyledTabs = styled(Tabs)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.n30};
`;

function BrokersActivityWidget() {
  const { t } = useTranslation("pages");
  const [activeTab, setActiveTab] = useState<BrokerActivityTabs>(
    BrokerActivityTabs.VIEWED_PROPERTIES
  );

  const tabMap: Record<BrokerActivityTabs, () => ReactNode> = {
    [BrokerActivityTabs.VIEWED_PROPERTIES]: () => (
      <PaginationProvider>
        <ModalProvider>
          <>
            <ViewedProperties />
            {/* <SubscriptionChangeConfirmationModal />
            <UpgradeSubscriptionModal
              type={UpgradeSubscriptionModalType.PORTFOLIO}
            /> */}
          </>
        </ModalProvider>
      </PaginationProvider>
    ),
    [BrokerActivityTabs.ADDED_TO_PORTFOLIO]: () => (
      <PaginationProvider>
        <ModalProvider>
          <>
            <AddedToPortfolio />
            <SubscriptionChangeConfirmationModal />
            <UpgradeSubscriptionModal
              type={UpgradeSubscriptionModalType.PORTFOLIO}
            />
          </>
        </ModalProvider>
      </PaginationProvider>
    ),
  };

  return (
    <Box w="100%">
      <StyledTabs
        variation="secondary"
        tabs={[
          {
            key: BrokerActivityTabs.VIEWED_PROPERTIES,
            label: t("dashboardPage.viewedProperties.viewedProperties"),
          },
          {
            key: BrokerActivityTabs.ADDED_TO_PORTFOLIO,
            label: t("dashboardPage.addedToPortfolio.addedToPortfolio"),
          },
        ]}
        activeTab={activeTab}
        onClick={(tab) => setActiveTab(tab as BrokerActivityTabs)}
        w="100%"
      />
      {tabMap[activeTab]() || null}
    </Box>
  );
}

export default BrokersActivityWidget;
